
export enum OnlineStatus {
    Offline,
    Online,
    Away,
}